export default "assets/images/quote-1916977c.png";